import axios from "axios";
import { store } from "@/store.js"; //Глобальное хранилище данных
// import Cookies from "js-cookie";
// axios.defaults.baseURL = `//staging.api.skyservice.online/`//`//online.skyservice.pro/${store.lang}`;
// axios.defaults.baseURL = `//staging.api.skyservice.online/`
axios.defaults.baseURL = `//staging.api.skyservice.online/`;

try {
  /*Для отладки*/
  // var host = window.location.host;
  // var subdomain = host.split('.')[0];
  // console.log(subdomain, 'subdomain')
  if (process.env.NODE_ENV == "production") {
    const hostURL = window.location.host.replace(/\..+/, ".");
    // axios.defaults.baseURL = `//api.skyservice.online/`
    axios.defaults.baseURL = `//${hostURL}api.skyservice.online/`;
    // https://xn-e28h.tpay.skyservice.online/?tpayid=4bc70558-2ed1-43fc-8641-342b6be47447
  } else {
    const params = new URLSearchParams(window.location.search);
    const allParams = {};
    params.forEach((value, key) => {
      allParams[key] = value;
    });
    delete allParams.tpayid;
    const urlSearchParams = new URLSearchParams(allParams).toString();
    const searchParams = urlSearchParams ? "&" + urlSearchParams : "";

    axios.defaults.params = {
      tpayid: "27e91a08-2b60-401e-9a2c-1b2e3aa897ea",
    };
    // Cookies.set("token", "c3fe59db-e16c-4c6e-b3ec-c13a6cd48319");
    window.history.pushState(
      "",
      "",
      "/?tpayid=27e91a08-2b60-401e-9a2c-1b2e3aa897ea" + searchParams
    );
  }
} catch (err) {
  console.log(err);
  //Не удалось прописать метод авторизации для локальной разработки
}

// ловим айди столика и записываем в стор
let url = new URL(window.location.href);
let tPayId = url.searchParams.get("tpayid");
console.log(url.searchParams.get("tpayid"));
if (tPayId) {
  store.tpayId = tPayId;
} else {
  throw new Error("tPayId is empty!");
}

//Добавить перехватчик запроса
axios.interceptors.request.use(
  function (config) {
    //Сделайте что-нибудь до отправки запроса
    try {
      if (config.params.concatenation != "true") {
        store.loader = true;
      }
      delete config.params.concatenation;
    } catch (err) {
      store.loader = true;
    }
    return config;
  },
  function (error) {
    console.log(error);
    store.loader = false;
    //Сделать что-то с ошибкой запроса
    return Promise.reject(error);
  }
);

//Добавить перехватчик ответа
axios.interceptors.response.use(
  function (response) {
    //Сделайте что-нибудь с ответными данными
    store.loader = false;
    if (response.status === 204) {
      return {
        data: {
          foundRows: 0,
          total: 0,
        },
      };
    }
    return response;
  },
  function (error) {
    // Сделать что-то с ошибкой ответа
    store.loader = false;
    try {
      if (
        JSON.parse(JSON.stringify(error)).response.status == 401 &&
        process.env.NODE_ENV == "production"
      ) {
        window.location = "/";
      }
    } catch (err) {
      console.log(err);
    }
    return Promise.reject(error);
  }
);

export class Start {
  //Получение данных для начала работы
  getStart() {
    // { params: { tpayid: store.tpayId } }
    return axios
      .get(`?action=getStart&section=tpay`, {
        params: { tpayid: store.tpayId },
      })
      .then((response) => response.data);
  }
}

export class Review {
  //Получение данных для начала работы
  sendReview(data) {
    return axios
      .post(`?action=saveReview&section=qrmenu`, data, {
        params: { tpayid: store.tpayId },
      })
      .then((response) => response.data);
  }
}

export class Payment {
  //portmone
  createPayment(params) {
    return axios
      .get(`?action=orderPayment&section=tpay`, { params })
      .then((response) => response.data);
  }
}

// Api на отримання замовлень
export class GetOrders {
  getorder(id) {
    return axios
      .get(`?action=getOrder&section=tpay&orderId=${id}`)
      .then((response) => response.data);
  }
}
